import axios from 'axios'
import { GLOBAL_DOMAIN, TOKEN_GENERATION_KEY } from '../../Config/Config'

const api = axios.create({
  baseURL: GLOBAL_DOMAIN,
})

let authToken = null
let globalWebsiteId = null

// Generate token and set websiteId
const generateToken = async () => {
  try {
    const response = await axios.get(`${GLOBAL_DOMAIN}commonservice`, {
      params: {
        type: 'generateToken',
        id: TOKEN_GENERATION_KEY,
      },
    })

    authToken = response.data.token
    globalWebsiteId = response.data.website_id

    return {
      token: authToken,
      website_id: globalWebsiteId,
    }
  } catch (error) {
    console.error('Error generating token:', error)
    throw error
  }
}

// Safe getter
export const getWebsiteId = () => globalWebsiteId

// Request interceptor for token
api.interceptors.request.use(
  (config) => {
    if (authToken) {
      config.headers.token = authToken
    }
    return config
  },
  (error) => Promise.reject(error)
)

// Response interceptor for token refresh
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true
      try {
        const { token } = await generateToken()
        originalRequest.headers.token = token
        return api(originalRequest)
      } catch (tokenError) {
        console.error('Failed to generate token:', tokenError)
        return Promise.reject(tokenError)
      }
    }
    return Promise.reject(error)
  }
)

// API methods
export const fetchData = async (endpoint) => {
  try {
    const response = await api.get(endpoint)
    return response.data
  } catch (error) {
    console.error('Error fetching data:', error)
    throw error
  }
}

export const postData = async (endpoint, data) => {
  try {
    const response = await api.post(endpoint, data)
    return response.data
  } catch (error) {
    console.error('Error posting data:', error)
    throw error
  }
}

export const updateData = async (endpoint, data) => {
  try {
    const response = await api.put(endpoint, data)
    return response.data
  } catch (error) {
    console.error('Error updating data:', error)
    throw error
  }
}

export const deleteData = async (endpoint) => {
  try {
    const response = await api.delete(endpoint)
    return response.data
  } catch (error) {
    console.error('Error deleting data:', error)
    throw error
  }
}

export const initializeApi = async () => {
  try {
    await generateToken()
  } catch (error) {
    console.error('Failed to initialize API token:', error)
  }
}
